
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 180"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2106","transform":"translate(-1169 -117)","fill":"#42ddb3"}},[_c('rect',{attrs:{"data-name":"Rectangle 3303","width":"24","height":"120","rx":"12","transform":"translate(1217 117)"}}),_c('path',{attrs:{"data-name":"Polygon 106","d":"M1236.682 251.781a10 10 0 01-15.364 0l-38.65-46.38A10 10 0 011190.35 189h77.3a10 10 0 017.682 16.4z"}}),_c('rect',{attrs:{"data-name":"Rectangle 3304","width":"120","height":"24","rx":"10","transform":"translate(1169 273)"}})])])
          )
        }
      }
    